module.exports = __webpack_public_path__ + "static/media/5.48e9c166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/thumbs/5.jpg
// module id = 151
// module chunks = 0